import React from "react";

/**
 * Multi-select age range picker rendered as a checkbox row.
 * Props:
 *  - options: ["Youth", "High School", ...]
 *  - value: array of selected age strings
 *  - onChange: (newArray) => void
 *  - testIdPrefix: optional prefix for data-testid
 */
export default function AgeRangePicker({
    options = [],
    value = [],
    onChange,
    testIdPrefix = "age-range",
}) {
    const toggle = (opt) => {
        const set = new Set(value);
        if (set.has(opt)) {
            set.delete(opt);
        } else {
            set.add(opt);
        }
        // Preserve canonical option order
        onChange(options.filter((o) => set.has(o)));
    };

    return (
        <div
            className="flex flex-wrap gap-2"
            data-testid={`${testIdPrefix}-picker`}
        >
            {options.map((opt) => {
                const selected = value.includes(opt);
                const slug = opt.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                return (
                    <button
                        type="button"
                        key={opt}
                        onClick={() => toggle(opt)}
                        aria-pressed={selected}
                        data-testid={`${testIdPrefix}-${slug}`}
                        className={[
                            "inline-flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-[0.18em] font-semibold border transition-colors select-none",
                            selected
                                ? "border-[#FF3B30] bg-[#FF3B30]/15 text-white"
                                : "border-white/15 bg-black/30 text-zinc-400 hover:border-white/40 hover:text-white",
                        ].join(" ")}
                    >
                        <span
                            className={[
                                "w-3.5 h-3.5 border flex-shrink-0 inline-flex items-center justify-center",
                                selected
                                    ? "border-[#FF3B30] bg-[#FF3B30]"
                                    : "border-white/30 bg-transparent",
                            ].join(" ")}
                        >
                            {selected && (
                                <svg
                                    width="9"
                                    height="9"
                                    viewBox="0 0 9 9"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 4.5L3.5 7L8 1.5"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            )}
                        </span>
                        {opt}
                    </button>
                );
            })}
        </div>
    );
}
